module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.334b3a35.mp3";